import { ENDPOINTS, useCreatePayload, fetchPlainResource, createCacheKey } from 'hammock';
import { useMutation } from 'react-query';

export const useDownloadAnalyticsQuery = (queryParams: Record<string, string | null>) => {
  const { action } = useCreatePayload(ENDPOINTS.analyticQueries);
  const { ts, uti, uts, ti, contentId, f, q, qf } = queryParams;

  const { mutateAsync, ...mutateUtils } = useMutation({
    mutationKey: createCacheKey(
      action({
        name: 'csv',
        query: { ti, ts, uti, uts, contentId, f, q, qf },
      }),
    ),
    mutationFn: (mutationParams: { queryId: string; [e: string]: unknown }) =>
      fetchPlainResource(
        action({
          name: 'csv',
          query: { ...mutationParams, ti, ts, uti, uts, contentId, f, q, qf },
        }),
      ),
  });

  return { download: mutateAsync, ...mutateUtils };
};
